import { CalendarDays, ClipboardList, Ticket, UsersRound, type LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

type DashboardQuickMenuProps = {
  isPausedSite: boolean;
};

type QuickMenuItem = {
  label: string;
  to: string;
  icon: LucideIcon;
};

const quickMenuItems: QuickMenuItem[] = [
  { label: "예약현황", to: "/daily-reservation-list", icon: ClipboardList },
  { label: "캘린더", to: "/reservation-calendar", icon: CalendarDays },
  { label: "티켓목록", to: "/ticket-list", icon: Ticket },
  { label: "단체예약", to: "/group-reservation-requests", icon: UsersRound },
];

export default function DashboardQuickMenu({ isPausedSite }: DashboardQuickMenuProps) {
  if (isPausedSite) return null;

  return (
    <div className="card crm-widget mb-4">
      <div className="card-body" style={{ padding: "22px 26px" }}>
        <div className="d-flex flex-column gap-3">
          <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
            <h4 className="card-title mb-0" style={{ color: "#4B465C" }}>
              빠른 메뉴
            </h4>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
            {quickMenuItems.map((item) => {
              const Icon = item.icon;

              return (
                <Link
                  aria-label={item.label}
                  className="d-flex w-100 align-items-center gap-2 rounded border text-decoration-none"
                  key={item.to}
                  style={{
                    minHeight: "50px",
                    padding: "10px 12px",
                    color: "#4B465C",
                    background: "rgba(115, 103, 240, 0.06)",
                    borderColor: "rgba(115, 103, 240, 0.18)",
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                  to={item.to}
                >
                  <span
                    className="d-inline-flex align-items-center justify-content-center rounded"
                    style={{
                      width: "26px",
                      height: "26px",
                      color: "#7367F0",
                      background: "rgba(115, 103, 240, 0.12)",
                      flex: "0 0 26px",
                    }}
                  >
                    <Icon aria-hidden="true" size={16} strokeWidth={2.2} />
                  </span>
                  <span className="text-truncate">{item.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
